import { Select, SelectProps } from '@mantine/core';
import classes from '@/components/StyledInputFields/Inputs.module.css';
import { useCapabilityHelpLabel } from '@/pages/Editor/components/StepSidebar/CapabilityHelpContext.tsx';

type StyledSelectProps = SelectProps & { capabilityFieldId?: string };

const StyledSelect = ({ capabilityFieldId, ...props }: StyledSelectProps) => {
  const label = useCapabilityHelpLabel(props.label, capabilityFieldId);
  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onTouchStart={(e) => e.stopPropagation()}
    >
      <Select
        checkIconPosition="right"
        clearable={true}
        {...props}
        label={label}
        classNames={{
          dropdown: classes.dropdown,
          option: classes.option,
          input: classes.input,
          label: classes.label,
          root: classes.root,
          description: classes.description,
          wrapper: classes.wrapper,
        }}
      />
    </div>
  );
};

export default StyledSelect;
